"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeSleep = void 0;
class IkeSleep {
    /**
     * Wait for duration ms;
     * @param duration Number of ms to wait
     */
    static sleep(duration) {
        return new Promise((resolve) => setTimeout(resolve, duration));
    }
}
exports.IkeSleep = IkeSleep;
//# sourceMappingURL=sleep.js.map